import { Component, OnInit } from '@angular/core';
import { Product, TranslatePipe } from '@spartacus/core';
import { CurrentProductService, SupplementHashAnchorsPipe } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-product-details-tab',
    templateUrl: './efa-product-details-tab.component.html',
    imports: [AsyncPipe, TranslatePipe, SupplementHashAnchorsPipe]
})
export class EfaProductDetailsTabComponent implements OnInit {
  product$: Observable<Product>;
  constructor(protected currentProductService: CurrentProductService){ }

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
  }
}
